import * as thunk from './Dashboard.thunk';

export const dashboard = {
  thunk,
};
